import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const useScrollTo = () => {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) return;

    const element = document.getElementById(hash.replace("#", ""));

    if (!element) return;

    element.scrollIntoView({ behavior: "smooth" });
  }, [hash]);
};

export default useScrollTo;
